var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/icons/img-alt.svg")}}),_c('div',{staticClass:"text-center text-primary font-bold text-xl mt-4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-center text-gray-500 font-medium"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }